export const cleanupMobileModifications = (navList: HTMLElement | null) => {
  removeToggleButtons();
  unwrapElements();
  removeMobileClasses(navList);
};

const removeToggleButtons = () => {
  document
    .querySelectorAll(".mobile-toggle")
    .forEach((toggle) => toggle.remove());
};

const unwrapElements = () => {
  document
    .querySelectorAll("#primary-menu .flex.items-center.justify-between")
    .forEach((wrapper) => {
      const parent = wrapper.parentElement;
      if (parent) {
        while (wrapper.firstChild) {
          parent.insertBefore(wrapper.firstChild, wrapper);
        }
        wrapper.remove();
      }
    });
};

const removeMobileClasses = (navList: HTMLElement | null) => {
  const menuList = navList?.querySelector("ul") || navList;
  if (menuList) {
    menuList.querySelectorAll("ul").forEach((ul) => {
      ul.classList.remove("pl-6", "hidden");
      // Restore desktop hidden class for first level
      if (ul.parentElement?.parentElement === menuList) {
        ul.classList.add("lg:hidden");
      }
    });
  }
};

